/* Banner mit Freistellern (sections/lp-cutout-banners.liquid): Produkte steigen beim Einblenden gestaffelt auf,
   neigen sich beim Scrollen (senkrecht: --p) und Wischen (waagerecht: --q). Nur solange die Section sichtbar ist. */
(() => {
  if (customElements.get('lp-cutout-banners')) return;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  class LpCutoutBanners extends HTMLElement {
    connectedCallback() {
      this.cards = [...this.querySelectorAll('.lp-cb__card')];
      if (!this.cards.length) return;
      this.track = this.querySelector('[data-track]');
      if (!reduce.matches) this.classList.add('is-armed');

      // Einblenden je Karte (auch beim Wischen auf dem Handy); danach normale Hover-Übergänge
      this.reveal = new IntersectionObserver((entries) => {
        for (const e of entries) {
          if (!e.isIntersecting) continue;
          const c = e.target;
          c.classList.add('is-in');
          this.reveal.unobserve(c);
          setTimeout(() => c.classList.add('is-done'), 1000 + Number(c.style.getPropertyValue('--n') || 0) * 110);
        }
      }, { threshold: 0.35 });
      this.cards.forEach((c) => this.reveal.observe(c));

      this.on = false;
      this.raf = 0;
      this.schedule = () => { if (this.on && !this.raf) this.raf = requestAnimationFrame(() => this.tick()); };
      this.observer = new IntersectionObserver(([e]) => { this.on = e.isIntersecting; this.schedule(); });
      this.observer.observe(this);
      window.addEventListener('scroll', this.schedule, { passive: true });
      window.addEventListener('resize', this.schedule, { passive: true });
      this.track?.addEventListener('scroll', this.schedule, { passive: true });
    }

    disconnectedCallback() {
      this.reveal?.disconnect();
      this.observer?.disconnect();
      window.removeEventListener('scroll', this.schedule);
      window.removeEventListener('resize', this.schedule);
      cancelAnimationFrame(this.raf);
    }

    tick() {
      this.raf = 0;
      if (!this.on || reduce.matches) return;
      const vw = window.innerWidth;
      const vh = window.innerHeight;
      for (const c of this.cards) {
        const r = c.getBoundingClientRect();
        const p = Math.max(-1, Math.min(1, (r.top + r.height / 2 - vh / 2) / vh));
        const q = Math.max(-1, Math.min(1, (r.left + r.width / 2 - vw / 2) / vw));
        c.style.setProperty('--p', p.toFixed(3));
        c.style.setProperty('--q', q.toFixed(3));
      }
    }
  }

  customElements.define('lp-cutout-banners', LpCutoutBanners);
})();
